import { render, staticRenderFns } from "./BlockTest.vue?vue&type=template&id=a85f15b2&scoped=true&"
import script from "./BlockTest.vue?vue&type=script&lang=js&"
export * from "./BlockTest.vue?vue&type=script&lang=js&"
import style0 from "./BlockTest.vue?vue&type=style&index=0&id=a85f15b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85f15b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
